export const dowel_bodyweight_squat = {
  title: 'Dowel Bodyweight Squat',
  dysfunctions: [
    'Weight shifts forward/forward lean during initial movement',
    'Forward bend at waist later in eccentric phase',
    'Elbows go back / thoracic spine collapses during initial movement',
    'Frontal plane shift',
    'Pelvis tucks under',
    'Knees Fall In',
    'Toes turn out during rep'
  ]
};

export const dowel_standing_hip_hinge = {
  title: 'Dowel Standing Hip Hinge',
  dysfunctions: [
    'Hinging from hips',
    'Deviation of hips',
    'Hyper kyphosis',
    'Pelvis tucks under',
    'Overextension of lumbar erectors during concentric phase'
  ]
};

export const ng_shoulder_width_lat_pull_down = {
  title: 'Ng Shoulder Width Lat Pull Down',
  dysfunctions: [
    'Internal rotation of shoulder',
    'Cannot retract and depress scapula',
    'Excessive lumbar curve',
    'Lack of Thoracic Extension',
    'Lacks ability to initiate movement with the back.'
  ]
};

export const dowel_standing_shoulder_press = {
  title: 'Dowel Standing Shoulder Press',
  dysfunctions: [
    'Weight in front of head',
    'Excessive lumbar curve',
    'Failure of full flexion of elbow and abduction at shoulder',
    'Asymmetry of scap/humerous rhythm'
  ]
};

export const db_front_foot_elevated_split_squat = {
  title: 'Db Front Foot Elevated Split Squat',
  dysfunctions: [
    'Lean forward/swing up',
    'Knee falls in and hip falls out',
    'Weight onto toe',
    'Excessive Lumbar Curve',
    'Pelvis tucks under'
  ]
};
